import React, { useState } from 'react';
import './Modal.scss';
import { CloseIcon } from '../svg/index';

interface ConfirmModalProps {
    isOpen: boolean;
    close: () => void;
    confirm: () => void;
    message: string; 
    title: string; 
    buttonText: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ isOpen, close, confirm, message, title, buttonText }) => {
    if (!isOpen) return null;

    return (
        <div className='modal'>
            <div className='modal-content'>
                <div className='text-wrapper'>
                    <div className="header-wrapper">
                        <div className="header-content">
                            <svg className='header-svg' width="34" height="31" viewBox="0 0 34 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.20077 30.2611C3.40566 30.2611 2.71655 30.0861 2.13347 29.7363C1.56098 29.397 1.11572 28.9306 0.797671 28.3369C0.479624 27.7538 0.320601 27.1018 0.320601 26.3809C0.320601 25.7554 0.495527 25.1246 0.845378 24.4885L13.3446 2.12982C13.7051 1.48312 14.1874 0.995452 14.7917 0.666804C15.4066 0.327554 16.0427 0.157929 16.7 0.157929C17.3573 0.157929 17.9881 0.327554 18.5924 0.666804C19.1967 0.995452 19.6791 1.48312 20.0395 2.12982L32.5547 24.4726C32.7243 24.7801 32.8515 25.0928 32.9363 25.4109C33.0211 25.7289 33.0635 26.0522 33.0635 26.3809C33.0635 27.1018 32.9045 27.7538 32.5865 28.3369C32.279 28.9306 31.8337 29.397 31.2507 29.7363C30.6676 30.0861 29.9785 30.2611 29.1834 30.2611H4.20077ZM16.7159 19.6224C17.5428 19.6224 17.9616 19.1877 17.9722 18.3184L18.2107 9.66753C18.2213 9.25407 18.0782 8.90952 17.7814 8.63388C17.4951 8.34764 17.1347 8.20452 16.7 8.20452C16.2547 8.20452 15.889 8.34234 15.6028 8.61798C15.3271 8.89362 15.1946 9.23817 15.2052 9.65163L15.4119 18.3184C15.4331 19.1877 15.8678 19.6224 16.7159 19.6224ZM16.7159 24.9497C17.193 24.9497 17.6064 24.7854 17.9563 24.4567C18.3168 24.1281 18.497 23.7252 18.497 23.2481C18.497 22.7711 18.3168 22.3682 17.9563 22.0396C17.6064 21.7003 17.193 21.5307 16.7159 21.5307C16.2282 21.5307 15.8095 21.7003 15.4596 22.0396C15.1098 22.3788 14.9349 22.7817 14.9349 23.2481C14.9349 23.7252 15.1098 24.1281 15.4596 24.4567C15.8201 24.7854 16.2388 24.9497 16.7159 24.9497Z" fill="#DE750C" />
                            </svg>
                            <h2 className="header">{title}</h2>
                        </div>
                        <button className="close-icon" onClick={close}>
                            <CloseIcon />
                        </button>
                    </div>
                    <p className="text" dangerouslySetInnerHTML={{ __html: message }} />
                </div>
                <div className='button-wrapper'>
                    <auro-button variant="secondary" fluid onClick={close}>
                        <span className="btnlabel-blue">No</span>
                    </auro-button>
                    <auro-button variant="primary" fluid onClick={confirm}>
                        <span className="btnlabel-white">{buttonText}</span>
                    </auro-button>
                </div>
            </div>
        </div>
    );
  }

export default ConfirmModal;